import type { CityConfig } from "@/pages/city-template/types";

export const hudsonConfig: CityConfig = {
  city: "Hudson",
  state: "New York",
  stateAbbr: "NY",
  slug: "hudson-ny",
  route: "/cities/hudson-ny",
  title: "Emergency & Expedited Passport Hudson NY | Same Day Passport Hudson",
  metaDescription:
    "Emergency passport Hudson NY — same day, 24-hour, and 3-5 day expedited passport processing for Columbia County. Fast Passport Center serves Hudson, Kinderhook, Chatham, and all north Hudson Valley communities.",
  h1: "Emergency & Expedited Passport Services in Hudson, NY",
  heroSubtitle:
    "Hudson's fast passport solution — from the historic port city to the Columbia County countryside. Whether you're flying out of Albany International or Stewart, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Historic%20waterfront%20city%20of%20Hudson%20New%20York%20along%20the%20Hudson%20River%2C%20charming%20Warren%20Street%20with%20antique%20shops%20and%20art%20galleries%2C%20Columbia%20County%20countryside%20with%20rolling%20farmland%20and%20distant%20hills%2C%20warm%20autumn%20golden%20light%2C%20modern%20travel%20photography%20with%20warm%20tones%2C%20no%20text%20overlay%2C%20scenic%20upstate%20New%20York%20river%20town%20with%20historic%20architecture%20and%20waterfront%20docks&width=1600&height=700&seq=ny-hudson-hero-001&orientation=landscape",
  heroImageAlt: "Historic Hudson New York waterfront along the Hudson River with Warren Street and Columbia County countryside at golden hour",
  geoPosition: "42.2528; -73.7900",
  geoPlacename: "Hudson, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~110 miles (South in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Hudson", zips: "12534" },
    { name: "Kinderhook", zips: "12106" },
    { name: "Chatham", zips: "12037" },
    { name: "Ghent", zips: "12075" },
    { name: "Philmont", zips: "12565" },
    { name: "Claverack", zips: "12513" },
    { name: "Athens", zips: "12015" },
    { name: "Stottville", zips: "12172" },
    { name: "Stockport", zips: "12534" },
    { name: "Germantown", zips: "12526" },
    { name: "Stuyvesant", zips: "12173" },
    { name: "New Baltimore", zips: "12124" },
    { name: "Austerlitz", zips: "12017" },
    { name: "Cairo", zips: "12413" },
    { name: "Catskill", zips: "12414" },
    { name: "Red Hook", zips: "12571" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Albany", zips: "12201-12260" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Hudson travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Hudson residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Columbia County",
      desc: "Hudson, Kinderhook, Chatham, and the entire Columbia County region — we serve all of the north Hudson Valley.",
    },
  ],
  testimonials: [
    {
      name: "William T.",
      location: "Hudson, NY",
      rating: 5,
      text: "Had an antique buying trip to Paris planned in a week. Fast Passport Center processed my expedited passport in 4 days. Their agent even helped me coordinate around my gallery schedule.",
      service: "Expedited Passport",
    },
    {
      name: "Catherine M.",
      location: "Kinderhook, NY",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center for my daughter's destination wedding in Italy. The 5-day option arrived in 4. They made it so easy for a busy retired teacher.",
      service: "Passport Renewal",
    },
    {
      name: "James R.",
      location: "Chatham, NY",
      rating: 5,
      text: "First-time passport for a business trip to London. The agent walked me through the DS-11 form and the acceptance clerk process at the Hudson Post Office. Got it in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "hudson-1",
      name: "Hudson Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "365 Fairview Avenue",
      city: "Hudson",
      state: "NY",
      zip: "12534",
      phone: "518-828-1575",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Hudson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Hudson passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "hudson-2",
      name: "Chatham Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "31 Main Street",
      city: "Chatham",
      state: "NY",
      zip: "12037",
      phone: "518-392-2221",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Chatham (~12 miles southeast)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Convenient for Chatham, Ghent, and east Columbia County residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "hudson-3",
      name: "Kinderhook Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "3 Hudson Street",
      city: "Kinderhook",
      state: "NY",
      zip: "12106",
      phone: "518-758-6114",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Kinderhook (~8 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Kinderhook, Stuyvesant, and south Columbia County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Hudson?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Hudson residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Hudson?",
      a: "The Hudson Post Office at 365 Fairview Avenue is the main Hudson passport acceptance facility. The Chatham Post Office at 31 Main Street and Kinderhook Post Office at 3 Hudson Street are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Hudson?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, and Rite Aid locations in Hudson, Kinderhook, and Chatham. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Hudson?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Hudson passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Hudson?",
      a: "The fastest way to renew a passport in Hudson is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Hudson?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Hudson and all Columbia County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Hudson?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Hudson. We serve Columbia County and the north Hudson Valley through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hudson", address: "various CVS locations in Hudson, Kinderhook, and Chatham", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Albany", address: "various Walgreens locations in Albany and Troy", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Hudson", address: "Rite Aid locations in Hudson and nearby Columbia County towns", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Albany", address: "various UPS Store locations in Albany", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Albany", address: "various FedEx Office locations in Albany", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Hudson",
      address: "560 Warren Street, Hudson, NY 12534",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Hudson DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Albany",
      address: "224-260 Washington Avenue Extension, Albany, NY 12203",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Albany DMV office serving Columbia County and Capital Region residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Catskill",
      address: "411 West Bridge Street, Catskill, NY 12414",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Catskill DMV office serving Greene County and west Columbia County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~40 miles from Hudson",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Albany International is the closest major airport to Hudson with flights to major U.S. and international destinations. Perfect for Columbia County travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "~55 miles from Hudson",
      address: "1180 First Street, New Windsor, NY 12553",
      note: "Stewart International is an alternative for Hudson travelers with flights to major U.S. hubs including Orlando and Las Vegas.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~110 miles from Hudson",
      address: "JFK Airport, Queens, NY 11430",
      note: "Major international airport with flights to every continent. Alternative for Hudson area travelers needing international connections.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Hudson travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Hudson residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Hudson residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Hudson residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Hudson, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Hudson residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Hudson travelers with immediate departure needs from Albany International." },
    { name: "Passport Renewal", description: "Fast passport renewal for Hudson residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Hudson residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Hudson residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Hudson and Columbia County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Hudson." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Hudson travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Hudson travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Hudson team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Hudson address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Beacon", route: "/cities/beacon" },
    { name: "Fishkill", route: "/cities/fishkill" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "Hyde Park", route: "/cities/hyde-park" },
    { name: "Red Hook", route: "/cities/red-hook" },
    { name: "Rhinebeck", route: "/cities/rhinebeck" },
    { name: "Catskill", route: "/cities/catskill" },
    { name: "Chatham", route: "/cities/chatham" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "Amsterdam", route: "/cities/amsterdam-ny" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Hudson and all of Columbia County as a remote courier service. We do not have a physical office in Hudson, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Hudson area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Hudson and all of Columbia County. From the historic port city on the Hudson River to the rural farmland of Kinderhook and Chatham — we serve the entire Hudson region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Hudson and all surrounding communities across Columbia County and the north Hudson Valley. Whether you're in Kinderhook, Chatham, or Ghent, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Hudson customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Hudson travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Hudson travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Hudson. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default hudsonConfig;